module.exports = __webpack_public_path__ + "img/id.31caec77.png";